(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aeoc-atc-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var modal = document.querySelector('[data-aeoc-modal]');
  if (!modal) return;
  var CODE = modal.getAttribute('data-code') || '';
  var CART_URL = modal.getAttribute('data-cart-url') || '/cart';
  var CUST_ORDERS = parseInt(modal.getAttribute('data-customer-orders') || '0', 10);
  var HERO = modal.getAttribute('data-hero') || 'unknown';
  var busy = false;   // one-shot in-flight guard shared by confirm + decline — prevents a double scoop add

  // cold paid-social detection, persisted for the session
  function detectCold(){
    try {
      var f = sessionStorage.getItem('aeoc_coldpaid');
      if (f === '1') return true;
      if (f === '0') return false;
      var p = new URLSearchParams(location.search);
      var med = (p.get('utm_medium') || '').toLowerCase();
      var src = (p.get('utm_source') || '').toLowerCase();
      var ref = (document.referrer || '').toLowerCase();
      var paid = med === 'paid' || med === 'cpc' || med.indexOf('paid') > -1;
      var social = src.indexOf('facebook') > -1 || src.indexOf('instagram') > -1 || src === 'fb' || src === 'ig';
      var refSocial = ref.indexOf('facebook') > -1 || ref.indexOf('instagram') > -1;
      var cold = (paid && social) || (paid && !src && refSocial);
      sessionStorage.setItem('aeoc_coldpaid', cold ? '1' : '0');
      return cold;
    } catch(e){ return false; }
  }
  var IS_COLD = detectCold();

  var cards = [].slice.call(modal.querySelectorAll('.mwl-up-card'));
  var confirmBtn = modal.querySelector('[data-aeoc-confirm]');
  var idle = confirmBtn ? confirmBtn.textContent : 'Add selected';
  // free measuring scoop opt-in (arm A only; present only on flagged products)
  var scoopEl = modal.querySelector('[data-scoop]');
  var scoopCb = scoopEl ? scoopEl.querySelector('.mwl-scoop-cb') : null;
  var SCOOP_ID = scoopEl ? (parseInt(scoopEl.getAttribute('data-scoop-id'), 10) || 0) : 0;
  function fmt(c){ return '$' + (Number(c) / 100).toFixed(2); }
  function picks(){ return cards.filter(function(c){ var cb = c.querySelector('.mwl-up-cb'); return cb && cb.checked; }); }
  function refresh(){
    var ch = picks(), t = 0;
    ch.forEach(function(c){ t += parseInt(c.getAttribute(IS_COLD ? 'data-off' : 'data-full'), 10) || 0; });
    var scoopOn = !!(scoopCb && scoopCb.checked);
    var scoopOnly = ch.length === 0 && scoopOn;
    if (confirmBtn){
      confirmBtn.disabled = ch.length === 0 && !scoopOnly;
      confirmBtn.textContent = ch.length ? ('Add ' + ch.length + (ch.length > 1 ? ' items' : ' item') + (scoopOn ? ' + free scoop' : '') + ' — ' + fmt(t)) : (scoopOnly ? 'Add my free scoop' : idle);
    }
  }
  cards.forEach(function(c){
    var cb = c.querySelector('.mwl-up-cb');
    if (cb) cb.addEventListener('change', function(){ c.classList.toggle('mwl-up-card--on', cb.checked); refresh(); });
  });
  if (scoopCb) scoopCb.addEventListener('change', function(){ if (scoopEl) scoopEl.classList.toggle('mwl-scoop--on', scoopCb.checked); refresh(); });

  // show the 15% ONLY to cold paid-social visitors; warm see full price everywhere
  var DISC = parseInt(modal.getAttribute('data-disc') || '15', 10);
  var footEl = modal.querySelector('[data-foot]');
  if (IS_COLD && CODE && DISC > 0) {
    cards.forEach(function(c){
      var full = parseInt(c.getAttribute('data-full'), 10), off = parseInt(c.getAttribute('data-off'), 10);
      var pe = c.querySelector('[data-price]');
      if (pe && off && off < full) pe.innerHTML = '<s>' + fmt(full) + '</s> <b>' + fmt(off) + '</b>';
    });
    if (footEl) footEl.textContent = DISC + '% off applied at checkout · added to this order — no second checkout';
  }

  function openModal(heroLine, cart){
    reconcileArm(heroLine);
    if (!applyCart(cart)) { goCart(); return; }   // nothing left to offer -> normal flow
    try {
      var n = parseInt(sessionStorage.getItem('aeoc_popup_count') || '0', 10) + 1;
      sessionStorage.setItem('aeoc_popup_count', String(n));
      var s = JSON.parse(sessionStorage.getItem('aeoc_popup_seen') || '{}') || {};
      s[HERO] = 1;
      sessionStorage.setItem('aeoc_popup_seen', JSON.stringify(s));
    } catch (e) {}
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    refresh();
  }
  function goCart(){ document.documentElement.style.overflow = ''; window.location.href = CART_URL; }
  function goCheckout(){ document.documentElement.style.overflow = ''; window.location.href = '/checkout'; }
  function closeOnly(){ document.documentElement.style.overflow = ''; modal.hidden = true; }
  // "No thanks, take me to checkout" — if the free scoop is ticked (arm A only), add it first, then go
  function declineFlow(){
    if (scoopCb && scoopCb.checked && SCOOP_ID && ARM === 'A') {
      if (busy) return; busy = true;
      document.documentElement.style.overflow = '';
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id: SCOOP_ID, quantity:1, properties:{_via:'scoop:'+HERO}}]})})
        .then(function(){ goCheckout(); }, function(){ goCheckout(); });
    } else {
      goCheckout();
    }
  }

  // decide the discount code (three-way gate)
  function decideCode(cb){
    if (!IS_COLD || !CODE){ cb(null); return; }      // warm -> full price
    if (CUST_ORDERS > 0){ cb(null); return; }         // logged-in returning -> full price
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var has = (cart.discount_codes || []).some(function(d){ return d.applicable; })
               || (cart.cart_level_discount_applications || []).length > 0;
        cb(has ? null : CODE);                         // existing code -> don't overwrite
      })
      .catch(function(){ cb(CODE); });
  }

  // intercept Add to Cart in CAPTURE phase so <product-form> never opens the drawer
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.closest('.product-form')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    // Frequency: at most 3 popups per session, and NEVER the same hero twice.
    // Accepting no longer switches it off — every PDP has its own companion pool
    // (custom.popup_pool), so a later product is a genuinely different offer, and the
    // customer who just said yes is the most receptive one in the store.
    // The counter is incremented in openModal, i.e. only when a popup actually shows.
    var shown = parseInt(sessionStorage.getItem('aeoc_popup_count') || '0', 10);
    var seen = {};
    try { seen = JSON.parse(sessionStorage.getItem('aeoc_popup_seen') || '{}') || {}; } catch(es){}
    if (seen[HERO] || shown >= 3) return;   // fall through -> normal add + cart drawer
    e.preventDefault(); e.stopImmediatePropagation();
    var vid = parseInt(idInput.value, 10);
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:vid, quantity:qty}]})})
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .then(function(d){
        var heroLine = d && d.items ? d.items[0] : d;
        // read the cart BEFORE opening so the popup can decline to show at all,
        // rather than appear and then empty itself
        return fetch('/cart.js', {headers:{'Accept':'application/json'}})
          .then(function(r2){ return r2.json(); })
          .then(function(cart){ openModal(heroLine, cart); })
          .catch(function(){ openModal(heroLine, null); });
      })
      .catch(goCart);
  }, true);

  if (confirmBtn) confirmBtn.addEventListener('click', function(){
    var ch = picks();
    var scoopOn = !!(scoopCb && scoopCb.checked);
    if (!ch.length && !scoopOn) return;
    if (busy) return; busy = true;
    try { sessionStorage.setItem('aeoc_popup_accepted', '1'); } catch(e3){}
    confirmBtn.disabled = true; confirmBtn.textContent = 'Adding…';
    var hadPaid = ch.length > 0;
    var items = ch.map(function(c){ return {id: parseInt(c.getAttribute('data-variant'), 10), quantity: 1, properties:{_via:'pdp-popup:'+HERO+':A:'+(IS_COLD?'cold':'warm')}}; });
    if (scoopOn && SCOOP_ID) items.push({id: SCOOP_ID, quantity: 1, properties:{_via:'scoop:'+HERO}});
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(){
        // the paid-upsell discount code only applies when a paid tile was taken;
        // a free-scoop-only confirm goes straight to checkout with no code
        if (!hadPaid) { document.documentElement.style.overflow = ''; window.location.href = '/checkout'; return; }
        decideCode(function(code){
          document.documentElement.style.overflow = '';
          window.location.href = code ? ('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout')) : '/checkout';
        });
      })
      .catch(goCart);
  });


  // ---------- A/B arm assignment (sticky per visitor) ----------
  var B_CARD   = modal.querySelector('[data-arm-card="B"]');
  var A_CARD   = modal.querySelector('[data-arm-card="A"]');
  var B_HEROES = (modal.getAttribute('data-b-heroes') || '').split(',').map(function(s){ return s.trim(); });
  var B_SPLIT  = parseFloat(modal.getAttribute('data-b-split') || '0.8');
  var B_CODES  = modal.getAttribute('data-b-codes') || '';
  var ARM = 'A';
  if (B_CARD && B_HEROES.indexOf(HERO) > -1) {
    // ?arm=A / ?arm=B forces an arm for THIS pageview only (QA). Deliberately not
    // persisted, so previewing can never contaminate a real visitor's assignment.
    var _q = null;
    try { _q = (new URLSearchParams(location.search)).get('arm'); } catch (eq) {}
    if (_q === 'A' || _q === 'B') { ARM = _q; }      // QA override ignores the gate
    else if (IS_COLD) {
      // Arm B's free powder is an ACQUISITION offer: cold paid-social only.
      // Warm / returning / organic visitors see the proven control at full price,
      // so we never give a $33 powder to someone already converted.
      try {
        var _a = localStorage.getItem('aeoc_popup_arm');
        if (_a !== 'A' && _a !== 'B') {
          _a = (Math.random() < B_SPLIT) ? 'B' : 'A';
          localStorage.setItem('aeoc_popup_arm', _a);
        }
        ARM = _a;
      } catch (e) { ARM = 'A'; }      // storage blocked -> fall back to the proven control
    }
  }
  if (ARM === 'B') { if (A_CARD) A_CARD.hidden = true; B_CARD.hidden = false; }
  else { if (B_CARD) B_CARD.hidden = true; if (A_CARD) A_CARD.hidden = false; }

  // Arm B's totals are rendered server-side from the variant present at page load.
  // If she switched variant or quantity before adding, those totals would be wrong,
  // so fall back to the proven control rather than show her a price we won't honour.
  // reconcileArm is RETIRED. It used to drop arm B -> arm A whenever the hero's
  // price x quantity did not match the price the card was rendered with, because the
  // totals were baked server-side. bApplyCart() now derives every total from the live
  // cart (B_CART_TOTAL = cart.total_price), so a qty-2 hero or a different variant
  // displays correctly on its own. The old guard was firing on ordinary qty-2 orders
  // and sending them to the control: 6 of 12 cold arm-A orders were qty 2, roughly
  // halving arm B's volume. Kept as a no-op so the call site needs no change.
  function reconcileArm(heroLine) { return; }

  // Both arms are rendered server-side and know nothing about what is already in her
  // cart. Feed them the live cart on every open so we never re-offer, re-add, or
  // mis-quote against a product she is already buying.
  // Returns false when the active arm has nothing left worth showing.
  function applyCart(cart){
    if (ARM === 'B') {
      if (typeof window.__aeocApplyCartB === 'function') window.__aeocApplyCartB(cart);
      return true;                       // arm B still has the free-gift offer to make
    }
    if (!cart || !cart.items) return cards.length > 0;
    var owned = {};
    cart.items.forEach(function(it){ owned[String(it.variant_id || it.id)] = true; });
    var live = 0;
    cards.forEach(function(c){
      var dup = !!owned[String(c.getAttribute('data-variant'))];
      c.hidden = dup;
      if (dup) {                          // never leave a hidden tile ticked
        var cb = c.querySelector('.mwl-up-cb');
        if (cb && cb.checked) { cb.checked = false; c.classList.remove('mwl-up-card--on'); }
      } else { live++; }
    });
    // if a free scoop is already coming in this cart, don't offer a second one
    if (scoopEl) {
      var hasScoop = SCOOP_ID && cart.items.some(function(it){ return String(it.variant_id || it.id) === String(SCOOP_ID); });
      scoopEl.hidden = !!hasScoop;
      if (hasScoop && scoopCb) { scoopCb.checked = false; scoopEl.classList.remove('mwl-scoop--on'); }
    }
    refresh();
    return live > 0;
  }

  // apply one or many comma-separated codes via the Ajax cart API, then checkout.
  // VERIFIED 7 Sep 2026: POST /cart/update.js {discount:"A,B"} attaches BOTH codes.
  // The /discount/A,B URL form does NOT work, and chaining redirects lands on "/".
  function goCodes(codes){
    document.documentElement.style.overflow = '';
    function done(){ window.location.href = '/checkout'; }
    if (!codes) { done(); return; }
    fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'},
                              body: JSON.stringify({discount: codes})})
      .then(done).catch(done);
  }

  // ---------- arm B: tick to unlock ----------
  // Both ticked  -> the deal: two products + free powder + free shipping, both codes.
  // One ticked   -> that product only, full price, NO codes (the Bxgy needs 3 qualifying
  //                 items and MOULDSHIP has a $55 minimum, so neither would apply anyway).
  // None ticked  -> CTA disabled.
  var bBtn = modal.querySelector('[data-aeoc-b-confirm]');
  if (bBtn && B_CARD) {
    var bOpts    = [].slice.call(B_CARD.querySelectorAll('[data-b-opt]'));
    var bFree    = B_CARD.querySelector('[data-b-free]');
    var bLock    = B_CARD.querySelector('[data-b-lock]');
    var bGrossRw = B_CARD.querySelector('[data-b-gross-row]');
    var bSaveRw  = B_CARD.querySelector('[data-b-save-row]');
    var bGrossEl = B_CARD.querySelector('[data-b-gross]');
    var bSaveEl  = B_CARD.querySelector('[data-b-save]');
    var bTotalEl = B_CARD.querySelector('[data-b-total]');
    var bNudgeEl = B_CARD.querySelector('[data-b-nudge]');
    var B_FREE_C = parseInt(B_CARD.getAttribute('data-b-free-cents') || '0', 10);
    var B_FREE_ID= parseInt(B_CARD.getAttribute('data-b-free-id')    || '0', 10);
    var B_SHIP_C = parseInt(B_CARD.getAttribute('data-b-ship-cents') || '0', 10);
    var B_HERO_C = parseInt(B_CARD.getAttribute('data-b-hero-cents') || '0', 10);
    var CTA_ALL  = bBtn.textContent;
    var CTA_ONE  = bBtn.getAttribute('data-cta-one')  || 'ADD TO MY ORDER';
    var CTA_NONE = bBtn.getAttribute('data-cta-none') || 'SELECT AT LEAST ONE';
    var NUDGE_T  = bNudgeEl ? (bNudgeEl.getAttribute('data-tpl') || '') : '';

    function bMoney(c){
      var s = (Math.round(c) / 100).toFixed(2).split('.');
      return '$' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1];
    }
    function bIsOn(o){ return o.getAttribute('aria-checked') !== 'false'; }
    function bOwned(o){ return o.getAttribute('data-owned') === '1'; }
    function bOn(){ return bOpts.filter(bIsOn); }
    // rows she ALREADY has in the cart count toward the unlock but must never be re-added
    function bToAdd(){ return bOpts.filter(function(o){ return bIsOn(o) && !bOwned(o); }); }
    function bSatisfied(){ return bOpts.every(function(o){ return bIsOn(o) || bOwned(o); }); }

    var B_CART_TOTAL = B_HERO_C;
    function bApplyCart(c){
      if (!c) return;
      B_CART_TOTAL = (typeof c.total_price === 'number') ? c.total_price : B_HERO_C;
      bOpts.forEach(function(o){
        var id = parseInt(o.getAttribute('data-id'), 10), have = 0;
        (c.items || []).forEach(function(it){
          if (it.variant_id === id || it.id === id) have += (it.quantity || 0);
        });
        o.setAttribute('data-owned', have > 0 ? '1' : '0');
        if (have > 0) {
          o.setAttribute('aria-checked', 'true');
          var val = o.querySelector('.mwl-b-val');
          if (val && !val.getAttribute('data-orig')) {
            val.setAttribute('data-orig', val.textContent);
            val.textContent = 'IN CART';
          }
        }
      });
      bSync();
    }

    function bSync(){
      var on    = bOn();
      var toAdd = bToAdd();
      var all   = bOpts.length > 0 && bSatisfied();
      // start from the REAL cart (it already includes the hero and anything added earlier)
      var sub = B_CART_TOTAL;
      toAdd.forEach(function(o){ sub += parseInt(o.getAttribute('data-price'), 10) || 0; });
      bOpts.forEach(function(o){
        o.classList.toggle('is-off', !bIsOn(o));
        o.classList.toggle('is-owned', bOwned(o));
      });

      if (bFree) bFree.classList.toggle('is-locked', !all);
      if (bLock) bLock.hidden = all;

      if (all) {
        if (bGrossRw) bGrossRw.hidden = false;
        if (bSaveRw)  bSaveRw.hidden  = false;
        if (bGrossEl) bGrossEl.textContent = bMoney(sub + B_FREE_C + B_SHIP_C);
        if (bSaveEl)  bSaveEl.textContent  = '\u2212' + bMoney(B_FREE_C + B_SHIP_C);
      } else {
        if (bGrossRw) bGrossRw.hidden = true;
        if (bSaveRw)  bSaveRw.hidden  = true;
      }
      if (bTotalEl) bTotalEl.textContent = bMoney(sub);

      bBtn.disabled = (toAdd.length === 0 && !all);
      bBtn.textContent = all ? CTA_ALL : (on.length ? CTA_ONE : CTA_NONE);

      // exactly one still missing -> show what it unlocks
      if (bNudgeEl) {
        var unmet = bOpts.filter(function(o){ return !bIsOn(o) && !bOwned(o); });
        if (unmet.length === 1 && !all) {
          var missing = unmet[0];
          bNudgeEl.textContent = NUDGE_T
            .replace('[item]',   missing.getAttribute('data-short') || missing.getAttribute('data-name'))
            .replace('[price]',  bMoney(parseInt(missing.getAttribute('data-price'), 10) || 0))
            .replace('[powder]', bMoney(B_FREE_C))
            .replace('[free]',   bMoney(B_FREE_C + B_SHIP_C));
          bNudgeEl.hidden = false;
        } else {
          bNudgeEl.hidden = true;
        }
      }
    }

    bOpts.forEach(function(o){
      function toggle(){
        if (bOwned(o)) return;               // already in her cart — not hers to untick
        o.setAttribute('aria-checked', bIsOn(o) ? 'false' : 'true');
        bSync();
      }
      o.addEventListener('click', toggle);
      o.addEventListener('keydown', function(ev){
        if (ev.key === ' ' || ev.key === 'Enter') { ev.preventDefault(); toggle(); }
      });
    });
    bSync();
    window.__aeocApplyCartB = bApplyCart;   // openModal feeds this the live cart

    bBtn.addEventListener('click', function(){
      var toAdd = bToAdd();
      var all   = bSatisfied();
      if (!toAdd.length && !all) return;
      try { sessionStorage.setItem('aeoc_popup_accepted', '1'); } catch (e4) {}
      var label = bBtn.textContent;
      bBtn.disabled = true; bBtn.textContent = 'Adding\u2026';

      var ids = toAdd.map(function(o){ return parseInt(o.getAttribute('data-id'), 10); })
                     .filter(function(n){ return n > 0; });
      if (all && B_FREE_ID > 0) ids.push(B_FREE_ID);   // powder ONLY when both are ticked
      if (!ids.length) { bBtn.disabled = false; bBtn.textContent = label; return; }

      var items = ids.map(function(id){
        return { id: id, quantity: 1, properties: { _via: 'pdp-popup:' + HERO + ':' + (all ? 'B' : 'Bsingle') + ':' + (IS_COLD ? 'cold' : 'warm') } };
      });
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'},
                              body: JSON.stringify({ items: items }) })
        .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){ goCodes(all ? B_CODES : ''); })
        .catch(goCart);
    });
  }

  modal.querySelectorAll('[data-aeoc-close]').forEach(function(el){ el.addEventListener('click', closeOnly); });
  modal.querySelectorAll('[data-aeoc-decline]').forEach(function(el){ el.addEventListener('click', declineFlow); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) closeOnly(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aeoc-switch-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var modal = document.querySelector('[data-aeoc-sw]');
  if (!modal) return;
  var CODE_A = modal.getAttribute('data-code-a') || '';
  var CODE_B = modal.getAttribute('data-code-b') || '';
  var CART_URL = modal.getAttribute('data-cart-url') || '/cart';
  var CUST_ORDERS = parseInt(modal.getAttribute('data-customer-orders') || '0', 10);
  var HERO = modal.getAttribute('data-hero') || 'unknown';
  var HERO_CENTS = parseInt(modal.getAttribute('data-hero-price') || '0', 10);

  function detectCold(){
    try {
      var f = sessionStorage.getItem('aeoc_coldpaid');
      if (f === '1') return true;
      if (f === '0') return false;
      var p = new URLSearchParams(location.search);
      var med = (p.get('utm_medium') || '').toLowerCase();
      var src = (p.get('utm_source') || '').toLowerCase();
      var ref = (document.referrer || '').toLowerCase();
      var paid = med === 'paid' || med === 'cpc' || med.indexOf('paid') > -1;
      var social = src.indexOf('facebook') > -1 || src.indexOf('instagram') > -1 || src === 'fb' || src === 'ig';
      var refSocial = ref.indexOf('facebook') > -1 || ref.indexOf('instagram') > -1;
      var cold = (paid && social) || (paid && !src && refSocial);
      sessionStorage.setItem('aeoc_coldpaid', cold ? '1' : '0');
      return cold;
    } catch(e){ return false; }
  }
  var IS_COLD = detectCold();

  var cards = [].slice.call(modal.querySelectorAll('.sw-card-item'));
  var confirmBtn = modal.querySelector('[data-aeoc-sw-confirm]');
  var totEl = modal.querySelector('[data-aeoc-sw-total]');
  var heroLbl = modal.querySelector('[data-aeoc-sw-herolbl]');
  function fmt(c){ return '$' + (Number(c) / 100).toFixed(2); }
  function eff(c){ return parseInt(c.getAttribute(IS_COLD ? 'data-off' : 'data-full'), 10) || 0; }
  function picks(){ return cards.filter(function(c){ var cb = c.querySelector('.sw-cb'); return cb && cb.checked; }); }
  function refresh(){
    var ch = picks(), add = 0;
    ch.forEach(function(c){ add += eff(c); });
    var cart = HERO_CENTS + add;
    if (totEl) totEl.textContent = fmt(cart);
    if (heroLbl) heroLbl.textContent = fmt(HERO_CENTS);
    if (confirmBtn) confirmBtn.textContent = ch.length ? ('Add ' + ch.length + (ch.length > 1 ? ' items' : ' item') + ' & checkout — ' + fmt(cart)) : 'Take me to checkout';
  }
  cards.forEach(function(c){
    var cb = c.querySelector('.sw-cb');
    if (cb) cb.addEventListener('change', function(){ c.classList.toggle('sw-card-item--on', cb.checked); refresh(); });
  });

  // cold paid-social new visitors: show the discounted prices + rate badges. warm: full price, no badge.
  cards.forEach(function(c){
    var full = parseInt(c.getAttribute('data-full'), 10), off = parseInt(c.getAttribute('data-off'), 10), rate = c.getAttribute('data-rate');
    var pe = c.querySelector('[data-price]'), be = c.querySelector('[data-badge]');
    var cold = IS_COLD && off && off < full;
    if (cold) {
      if (pe) pe.innerHTML = '<s>' + fmt(full) + '</s> <b>' + fmt(off) + '</b>';
      if (be) { be.textContent = rate + '% off'; be.className = 'sw-badge' + (parseInt(rate,10) >= 50 ? ' sw-badge--big' : ''); }
    } else {
      if (be) be.style.display = 'none';
    }
    // per-unit value line: powders show cost-per-wash off the price actually charged; others show a count
    var ue = c.querySelector('[data-unit]');
    if (ue) {
      var cnt = parseInt(ue.getAttribute('data-count'), 10) || 0;
      var nm = ue.getAttribute('data-name') || '';
      var effc = cold ? off : full;               // cents actually charged
      if (cnt && nm === 'washes') {
        var per = effc / cnt;                     // cents ÷ washes = ¢ per wash (exact)
        var perStr = (per % 1 === 0) ? per.toFixed(0) : per.toFixed(1);
        ue.textContent = cnt + ' washes · ' + perStr + '¢ per wash';
      } else if (cnt) {
        ue.textContent = '~' + cnt + ' ' + nm;
      }
    }
  });

  function openModal(){ modal.hidden = false; document.documentElement.style.overflow = 'hidden'; refresh(); }
  function goCart(){ document.documentElement.style.overflow = ''; window.location.href = CART_URL; }
  function closeOnly(){ document.documentElement.style.overflow = ''; modal.hidden = true; }

  // build the checkout URL, chaining BOTH codes for cold+new+no-existing-code carts.
  // NOTE: keep the innermost /checkout as a LITERAL slash and encode each layer EXACTLY once.
  // Encoding an already-encoded string (encodeURIComponent of "%2Fcheckout") yields "%252Fcheckout",
  // which Shopify's /discount route rejects -> silent bounce to the homepage.
  function chainURL(){
    if (CODE_A && CODE_B) {
      var inner = '/discount/' + encodeURIComponent(CODE_B) + '?redirect=/checkout';
      return '/discount/' + encodeURIComponent(CODE_A) + '?redirect=' + encodeURIComponent(inner);
    }
    if (CODE_A) return '/discount/' + encodeURIComponent(CODE_A) + '?redirect=/checkout';
    if (CODE_B) return '/discount/' + encodeURIComponent(CODE_B) + '?redirect=/checkout';
    return '/checkout';
  }
  function decideURL(cb){
    if (!IS_COLD || (!CODE_A && !CODE_B)) { cb('/checkout'); return; }   // warm -> full price
    if (CUST_ORDERS > 0) { cb('/checkout'); return; }                    // returning -> full price
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var has = (cart.discount_codes || []).some(function(d){ return d.applicable; })
               || (cart.cart_level_discount_applications || []).length > 0;
        cb(has ? '/checkout' : chainURL());                               // existing code -> don't overwrite
      })
      .catch(function(){ cb(chainURL()); });
  }

  // intercept Add to Cart in CAPTURE phase so <product-form> never opens the drawer
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.closest('.product-form')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var shown = parseInt(sessionStorage.getItem('aeoc_popup_count') || '0', 10);
    var accepted = sessionStorage.getItem('aeoc_popup_accepted') === '1';
    if (accepted || shown >= 2) return;
    e.preventDefault(); e.stopImmediatePropagation();
    try { sessionStorage.setItem('aeoc_popup_count', String(shown + 1)); } catch(e2){}
    var vid = parseInt(idInput.value, 10);
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:vid, quantity:qty}]})})
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .then(function(data){ try { if (data.items && data.items[0]) HERO_CENTS = data.items[0].final_line_price || HERO_CENTS; } catch(e3){} openModal(); })
      .catch(goCart);
  }, true);

  if (confirmBtn) confirmBtn.addEventListener('click', function(){
    var ch = picks();
    if (!ch.length) { document.documentElement.style.overflow = ''; window.location.href = '/checkout'; return; }
    try { sessionStorage.setItem('aeoc_popup_accepted', '1'); } catch(e3){}
    confirmBtn.disabled = true; confirmBtn.textContent = 'Adding…';
    var items = ch.map(function(c){ return {id: parseInt(c.getAttribute('data-variant'), 10), quantity: 1, properties:{_via:'pdp-popup:'+HERO}}; });
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(){ decideURL(function(url){ document.documentElement.style.overflow = ''; window.location.href = url; }); })
      .catch(goCart);
  });

  modal.querySelectorAll('[data-aeoc-sw-close]').forEach(function(el){ el.addEventListener('click', closeOnly); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) closeOnly(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.localStorage.getItem('announcementDismissed');

      if ( !ad ) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
    }

    hideAnnouncement() {
      window.localStorage.setItem("announcementDismissed", true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bottle-under-your-sink-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('bus'); if(!root)return;
  var form=root.querySelector('#bus-form');
  var card=root.querySelector('#bus-form-card');
  var success=root.querySelector('#bus-success');
  var companyId=root.dataset.companyId, listId=root.dataset.listId;

  function showSuccess(){
    if(form) form.hidden=true;
    if(success) success.hidden=false;
  }

  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var emailEl=root.querySelector('#bus-email'), nameEl=root.querySelector('#bus-name');
      var email=(emailEl.value||'').trim(), name=(nameEl.value||'').trim();
      if(!email || email.indexOf('@')===-1){ emailEl.focus(); return; }
      var btn=form.querySelector('button[type="submit"]');
      if(btn){ btn.disabled=true; btn.textContent='Sending…'; }

      if(!companyId || !listId){
        console.warn('[bus] Klaviyo company_id/list_id not configured — see HANDOFF doc. Showing success UI anyway.');
        showSuccess();
        return;
      }

      var body={
        data:{
          type:'subscription',
          attributes:{
            custom_source:'Ebook LP — The Bottle Under Your Sink',
            profile:{ data:{ type:'profile', attributes:{
              email:email,
              first_name: name || null,
              properties:{ lead_magnet:'the-bottle-under-your-sink' }
            } } }
          },
          relationships:{ list:{ data:{ type:'list', id:listId } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(companyId),{
        method:'POST',
        headers:{'Content-Type':'application/json', revision:'2024-10-15'},
        body:JSON.stringify(body)
      }).then(function(r){ console.log('[bus] Klaviyo subscribe HTTP', r.status); showSuccess(); })
        .catch(function(err){ console.warn('[bus] Klaviyo subscribe error', err); showSuccess(); });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clove-euc-mould-spray-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('cms'); if(!root)return;
  // carousel (only present when video URLs are set)
  var car=root.querySelector('[data-cms-carousel]');
  if(car){var track=car.querySelector('.cms-car-track'),dots=car.querySelectorAll('.cms-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.cms-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.cms-vid'),p=w&&w.querySelector('.cms-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    var _prev=car.querySelector('.cms-prev');if(_prev)_prev.onclick=function(){go(i-1);};
    var _next=car.querySelector('.cms-next');if(_next)_next.onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.cms-vid');if(!v)return;var vid=v.querySelector('.cms-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.cms-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.cms-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.cms-vid'),p=w&&w.querySelector('.cms-play');if(p)p.style.display='grid';});});
  }
  // before/after (only present when both images are set)
  var ba=root.querySelector('[data-cms-ba]');
  if(ba){var r=ba.querySelector('.cms-ba-range'),clip=ba.querySelector('.cms-ba-clip'),h=ba.querySelector('.cms-ba-handle'),k=ba.querySelector('.cms-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#cms-form'),sel=root.querySelector('#cms-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-cms-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#cms-buy-wrap')||{}).dataset?root.querySelector('#cms-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.cmsOpt,10)||0;
      var on=g.querySelector('.cms-chip.is-on')||g.querySelector('.cms-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.cms-chip');if(!c)return;
        g.querySelectorAll('.cms-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#cms-now'),was=root.querySelector('#cms-was'),
          sp=root.querySelector('#cms-sticky-price'),per=root.querySelector('#cms-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      var img=root.querySelector('#cms-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.cmsOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // auto Save %/$ badges from compare-at prices (lights up if Tony adds them later)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.cmsOpt,10)||0;
      sg.querySelectorAll('.cms-chip').forEach(function(ch){
        if(ch.querySelector('.cms-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='cms-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart upsell modal (multi-staple picker) ----------
    var modal=root.querySelector('[data-cms-modal]');
    if(modal){
      var cartUrl=modal.getAttribute('data-cart-url')||'/cart';
      var code=modal.getAttribute('data-code');
      var goCart=function(){window.location.href=cartUrl;};var goCheckout=function(){window.location.href='/checkout';};
      var fmt=function(cents){return '$'+(Number(cents)/100).toFixed(2);};
      var cards=[].slice.call(modal.querySelectorAll('.cms-up-card'));
      var confirmBtn=modal.querySelector('[data-cms-modal-confirm]');
      var idleLabel=confirmBtn?confirmBtn.textContent:'Add selected';
      function picks(){return cards.filter(function(c){var cb=c.querySelector('.cms-up-cb');return cb&&cb.checked;});}
      // Nothing is ever pre-ticked: browsers restore checkbox state on reload/bfcache,
      // which made the popup open with every item already selected.
      function resetPicks(){cards.forEach(function(c){var cb=c.querySelector('.cms-up-cb');if(cb)cb.checked=false;c.classList.remove('cms-up-card--on');});}
      function refresh(){
        var chosen=picks(),total=0;
        chosen.forEach(function(c){total+=parseInt(c.getAttribute('data-price'),10)||0;});
        if(confirmBtn){
          confirmBtn.disabled=chosen.length===0;
          confirmBtn.textContent=chosen.length?('Add '+chosen.length+(chosen.length>1?' items':' item')+' — '+fmt(total)):idleLabel;
        }
      }
      cards.forEach(function(c){var cb=c.querySelector('.cms-up-cb');
        if(cb)cb.addEventListener('change',function(){c.classList.toggle('cms-up-card--on',cb.checked);refresh();});});
      // intercept the native add-to-cart submit → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){resetPicks();modal.hidden=false;document.documentElement.style.overflow='hidden';refresh();})
          .catch(goCart);
      },true);
      // CONFIRM → add all selected staples, apply the code, land on cart
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=picks();if(!chosen.length)return;
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var items=chosen.map(function(c){return {id:parseInt(c.getAttribute('data-variant'),10),quantity:1,properties:{_via:'clovespray-popup'}};});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent('/checkout')):'/checkout';})
          .catch(goCart);
      });
      // X / backdrop / "no thanks" → proceed to cart (the hero product is already in it)
      modal.querySelectorAll('[data-cms-modal-close-go]').forEach(function(el){el.addEventListener('click',goCheckout);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCheckout();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
  class CollapsibleContent extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('.collapsible');
      this.content = this.querySelector('.accordion__content');
      this.transition = null;
      this.isClosing = false;
      this.isExpanding = false;

      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      this.transition = true;
      this.content.style.maxHeight = null;
      this.content.addEventListener(
        'transitionend',
        () => {
          this.onTransitionFinish(false);
        },
        { once: true }
      );
    }

    open() {
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      this.transition = true;
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      this.content.addEventListener(
        'transitionend',
        () => {
          this.onTransitionFinish(true);
        },
        { once: true }
      );
    }

    onTransitionFinish(open) {
      this.details.open = open;
      this.transition = null;
      this.isClosing = false;
      this.isExpanding = false;
    }
  }

  customElements.define('collapsible-content', CollapsibleContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floor-cleaner-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('flp'); if(!root)return;
  // carousel
  var car=root.querySelector('[data-flp-carousel]');
  if(car){var track=car.querySelector('.flp-car-track'),dots=car.querySelectorAll('.flp-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.flp-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.flp-vid'),p=w&&w.querySelector('.flp-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    car.querySelector('.flp-prev').onclick=function(){go(i-1);};
    car.querySelector('.flp-next').onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.flp-vid');if(!v)return;var vid=v.querySelector('.flp-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.flp-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.flp-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.flp-vid'),p=w&&w.querySelector('.flp-play');if(p)p.style.display='grid';});});
  }
  // before/after
  var ba=root.querySelector('[data-flp-ba]');
  if(ba){var r=ba.querySelector('.flp-ba-range'),clip=ba.querySelector('.flp-ba-clip'),h=ba.querySelector('.flp-ba-handle'),k=ba.querySelector('.flp-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#flp-form'),sel=root.querySelector('#flp-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-flp-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#flp-buy-wrap')||{}).dataset?root.querySelector('#flp-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.flpOpt,10)||0;
      var on=g.querySelector('.flp-chip.is-on')||g.querySelector('.flp-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.flp-chip');if(!c)return;
        g.querySelectorAll('.flp-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#flp-now'),was=root.querySelector('#flp-was'),
          sp=root.querySelector('#flp-sticky-price'),per=root.querySelector('#flp-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      // main product image follows the selected variant (scent swatch behaviour)
      var img=root.querySelector('#flp-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      // per-size subline follows the selected size
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.flpOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // anchoring badges on size chips: auto Save %/$ from compare-at (Rule of 100)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.flpOpt,10)||0;
      sg.querySelectorAll('.flp-chip').forEach(function(ch){
        if(ch.querySelector('.flp-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='flp-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart upsell modal (multi best-seller picker) ----------
    var modal=root.querySelector('[data-flp-modal]');
    if(modal){
      var cartUrl=modal.getAttribute('data-cart-url')||'/cart';
      var code=modal.getAttribute('data-code');
      var goCart=function(){window.location.href=cartUrl;};var goCheckout=function(){window.location.href='/checkout';};
      var fmt=function(cents){return '$'+(Number(cents)/100).toFixed(2);};
      var cards=[].slice.call(modal.querySelectorAll('.flp-up-card'));
      var confirmBtn=modal.querySelector('[data-flp-modal-confirm]');
      var idleLabel=confirmBtn?confirmBtn.textContent:'Add selected';
      function picks(){return cards.filter(function(c){var cb=c.querySelector('.flp-up-cb');return cb&&cb.checked;});}
      // Nothing is ever pre-ticked: browsers restore checkbox state on reload/bfcache,
      // which made the popup open with every staple already selected.
      function resetPicks(){cards.forEach(function(c){var cb=c.querySelector('.flp-up-cb');if(cb)cb.checked=false;c.classList.remove('flp-up-card--on');});}
      function refresh(){
        var chosen=picks(),total=0;
        chosen.forEach(function(c){total+=parseInt(c.getAttribute('data-price'),10)||0;});
        if(confirmBtn){
          confirmBtn.disabled=chosen.length===0;
          confirmBtn.textContent=chosen.length?('Add '+chosen.length+(chosen.length>1?' items':' item')+' — '+fmt(total)):idleLabel;
        }
      }
      cards.forEach(function(c){var cb=c.querySelector('.flp-up-cb');
        if(cb)cb.addEventListener('change',function(){c.classList.toggle('flp-up-card--on',cb.checked);refresh();});});
      // intercept the native add-to-cart submit → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){resetPicks();modal.hidden=false;document.documentElement.style.overflow='hidden';refresh();})
          .catch(goCart);
      },true);
      // CONFIRM → add all selected best sellers (tagged _via for tracking), apply code, land on cart
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=picks();if(!chosen.length)return;
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var items=chosen.map(function(c){return {id:parseInt(c.getAttribute('data-variant'),10),quantity:1,properties:{_via:'floor-popup'}};});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent('/checkout')):'/checkout';})
          .catch(goCart);
      });
      // X / backdrop / "no thanks" → proceed to cart (the hero product is already in it)
      modal.querySelectorAll('[data-flp-modal-close-go]').forEach(function(el){el.addEventListener('click',goCheckout);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCheckout();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.localization-list'),
        inputSearch: this.querySelector('#localization-search-input'),
        closeButton: this.querySelector('.modal__close-button'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this))
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      if (this.elements.inputSearch) {
        this.elements.inputSearch.addEventListener('keyup', this.filter.bind(this));
      }

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    filter(event) {
      const valThis = event.target.value;
      this.elements.panel.querySelectorAll('.disclosure__item').forEach((item) => {
        const text = item.querySelector('.localization-form__country-name').textContent;
        const textMatch = text.toLowerCase().indexOf(valThis.toLowerCase()) > -1;
        textMatch ? item.classList.remove('hide') : item.classList.add('hide');
      });

      const activeItems = this.elements.panel.querySelectorAll('.disclosure__item:not(.hide)');
      const noResultsMessage = this.elements.panel.querySelector('.disclosure__no-results');

      if (!activeItems.length) {
        noResultsMessage.classList.remove('hide');
      } else if (!noResultsMessage.classList.contains('hide')) {
        noResultsMessage.classList.add('hide');
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.button.classList.remove('disclosure__button--open');
      this.elements.panel.setAttribute('hidden', true);
      document.body.classList.remove('overflow-hidden-mobile');
      document.body.removeEventListener('click', this.onBodyClick);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      this.elements.button.classList.toggle('disclosure__button--open');
      document.body.classList.add('overflow-hidden-mobile');
      document.body.addEventListener('click', this.onBodyClick);
    }

    handleBodyClick(evt) {
      const target = evt.target;
      const closestForm = target.closest('localization-form');

      if (target !== this && !target.closest('localization-form')) {
        this.hidePanel();
      } else if (closestForm !== this) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glass-cleaner-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('slp'); if(!root)return;
  // carousel (only present when video URLs are set)
  var car=root.querySelector('[data-slp-carousel]');
  if(car){var track=car.querySelector('.slp-car-track'),dots=car.querySelectorAll('.slp-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.slp-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.slp-vid'),p=w&&w.querySelector('.slp-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    var _prev=car.querySelector('.slp-prev');if(_prev)_prev.onclick=function(){go(i-1);};
    var _next=car.querySelector('.slp-next');if(_next)_next.onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.slp-vid');if(!v)return;var vid=v.querySelector('.slp-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.slp-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.slp-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.slp-vid'),p=w&&w.querySelector('.slp-play');if(p)p.style.display='grid';});});
  }
  // before/after (only present when both images are set)
  var ba=root.querySelector('[data-slp-ba]');
  if(ba){var r=ba.querySelector('.slp-ba-range'),clip=ba.querySelector('.slp-ba-clip'),h=ba.querySelector('.slp-ba-handle'),k=ba.querySelector('.slp-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#slp-form'),sel=root.querySelector('#slp-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-slp-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#slp-buy-wrap')||{}).dataset?root.querySelector('#slp-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.slpOpt,10)||0;
      var on=g.querySelector('.slp-chip.is-on')||g.querySelector('.slp-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.slp-chip');if(!c)return;
        g.querySelectorAll('.slp-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#slp-now'),was=root.querySelector('#slp-was'),
          sp=root.querySelector('#slp-sticky-price'),per=root.querySelector('#slp-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      var img=root.querySelector('#slp-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.slpOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // auto Save %/$ badges from compare-at prices (lights up if Tony adds them later)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.slpOpt,10)||0;
      sg.querySelectorAll('.slp-chip').forEach(function(ch){
        if(ch.querySelector('.slp-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='slp-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart upsell modal (multi-staple picker) ----------
    var modal=root.querySelector('[data-slp-modal]');
    if(modal){
      var cartUrl=modal.getAttribute('data-cart-url')||'/cart';
      var code=modal.getAttribute('data-code');
      var goCart=function(){window.location.href=cartUrl;};var goCheckout=function(){window.location.href='/checkout';};
      var fmt=function(cents){return '$'+(Number(cents)/100).toFixed(2);};
      var cards=[].slice.call(modal.querySelectorAll('.slp-up-card'));
      var confirmBtn=modal.querySelector('[data-slp-modal-confirm]');
      var idleLabel=confirmBtn?confirmBtn.textContent:'Add selected';
      function picks(){return cards.filter(function(c){var cb=c.querySelector('.slp-up-cb');return cb&&cb.checked;});}
      // Nothing is ever pre-ticked: browsers (Chrome/Firefox) restore checkbox state on
      // reload/bfcache, which made the popup open with every staple already selected.
      function resetPicks(){cards.forEach(function(c){var cb=c.querySelector('.slp-up-cb');if(cb)cb.checked=false;c.classList.remove('slp-up-card--on');});}
      function refresh(){
        var chosen=picks(),total=0;
        chosen.forEach(function(c){total+=parseInt(c.getAttribute('data-price'),10)||0;});
        if(confirmBtn){
          confirmBtn.disabled=chosen.length===0;
          confirmBtn.textContent=chosen.length?('Add '+chosen.length+(chosen.length>1?' items':' item')+' — '+fmt(total)):idleLabel;
        }
      }
      cards.forEach(function(c){var cb=c.querySelector('.slp-up-cb');
        if(cb)cb.addEventListener('change',function(){c.classList.toggle('slp-up-card--on',cb.checked);refresh();});});
      // intercept the native add-to-cart submit → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){resetPicks();modal.hidden=false;document.documentElement.style.overflow='hidden';refresh();})
          .catch(goCart);
      },true);
      // CONFIRM → add all selected staples, apply the code, land on cart
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=picks();if(!chosen.length)return;
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var items=chosen.map(function(c){return {id:parseInt(c.getAttribute('data-variant'),10),quantity:1,properties:{_via:'glass-popup'}};});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent('/checkout')):'/checkout';})
          .catch(goCart);
      });
      // X / backdrop / "no thanks" → proceed to cart (the hero product is already in it)
      modal.querySelectorAll('[data-slp-modal-close-go]').forEach(function(el){el.addEventListener('click',goCheckout);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCheckout();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerHeight = this.header.offsetHeight;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      const backButton = this.header.querySelector('.header__back-button button');
      if (backButton) {
        const referrerUrl = document.referrer;
        const currentPathname = location.pathname;

        if (referrerUrl) {
          const createReferrerUrl = new URL(referrerUrl);
          const referrerPathname = createReferrerUrl.pathname;
          const referrerPathArray = referrerPathname.split('/');
          const currentpathArray = currentPathname.split('/');

          if (currentpathArray[currentpathArray.length - 1] !== referrerPathArray[referrerPathArray.length - 1]) {
            localStorage.setItem('archerReferredPath', referrerPathname);
            localStorage.setItem('archerReferredParams', createReferrerUrl.search);
            localStorage.setItem('archerCurrentPath', currentPathname);
          }
        }

        backButton.addEventListener('click', this.handleBackHistory.bind(this));
        return;
      }

      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.preventOpenSubmenu = false;
      this.openingMenu = false;
      this.closingMenu = false;
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseleave', this.handleMouseleave.bind(this)));

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.headerWrap.dataset.pageType !== 'product') {
        window.addEventListener('scroll', this.onScrollHandler, false);
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    handleBackHistory(event) {
      const historyLength = history.length;
      const backUrl = event.currentTarget.dataset.url;

      if (historyLength > 2) {
        history.back();
      } else {
        window.location.href = backUrl;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.top) {
        if (!this.header.classList.contains('shopify-section-header-light')) {
          this.header.classList.add('shopify-section-header-light');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerHeight) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerHeight) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-light');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-light', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-light', 'animate');
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item span');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open')) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      this.header.classList.add('shopify-section-header-light');

      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      window.clearTimeout(this.timeoutClose);
      this.closingMenu = true;

      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (!detailsElement) return;

      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove('shopify-section-header-light');
      }

      detailsElement.classList.remove('sub-menu-opening');
      detailsElement.removeAttribute('open');
      // this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 300) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.querySelector('.hero-media__video').dataset.ready = true;
    }, 1500);
  });

  const getYouTubeVideoIdFromUrl = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : undefined;
  };

  const getVimeoIdFromUrl = (url) => {
    const match = /vimeo.*\/(\d+)/i.exec(url);
    if (match) {
      return match[1];
    }
  };

  class HeroMedia extends HTMLElement {
    constructor() {
      super();
      const youTubeVideo = this.querySelector('.js-youtube-background-video');
      const vimeoVideo = this.querySelector('.js-vimeo-background-video');
      const customVideo = this.querySelector('video.hero__media-custom-video');
      this.sectionId = this.dataset.sectionId;
      this.autoplay = this.dataset.autoplayVideo;
      this.videoOverlay = this.querySelector('.js-video-overlay');

      if (youTubeVideo) {
        const bgVideoUrl = youTubeVideo.getAttribute('data-video');
        const bgVideoID = getYouTubeVideoIdFromUrl(bgVideoUrl);

        if (!bgVideoID) {
          return;
        }

        const defaults = {
          videoId: bgVideoID,
          playerVars: {
            autohide: 0,
            autoplay: 1,
            cc_load_policy: 0,
            controls: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
            enablejsapi: 1,
            origin: routes.shop_url,
          },
        };

        if (this.autoplay) {
          defaults.playerVars = {
            autohide: 0,
            autoplay: 1,
            cc_load_policy: 0,
            controls: 0,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
            enablejsapi: 1,
            origin: routes.shop_url,
          };
        } else {
          defaults.playerVars = {
            autohide: 0,
            autoplay: 0,
            cc_load_policy: 0,
            controls: 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
            enablejsapi: 1,
            origin: routes.shop_url,
          };
        }
        // API callback events
        defaults.events = {
          onReady: this.onPlayerReady.bind(this),
        };

        this.options = defaults;
        this.ytPlayer;

        if (window.youTubeReady) {
          this.initVideo();
        } else {
          document.addEventListener('youTubeReady', this.initVideo.bind(this));
        }
      }

      if (vimeoVideo) {
        let defaults = {
          byline: false,
          portrait: false,
          title: false,
        };

        if (this.autoplay) {
          let defaults = {
            background: true,
            autoplay: true,
            controls: false,
            loop: true,
            muted: true,
            byline: false,
            portrait: false,
            title: false,
          };
        }

        this.options = defaults;
        this.vimeoElm = document.getElementById(`vimeo-player-${this.sectionId}`);
        const bgVideoUrl = vimeoVideo.getAttribute('data-video');
        this.vimeoId = getVimeoIdFromUrl(bgVideoUrl);

        if (!this.vimeoId) {
          return;
        }

        if (window.vimeoReady) {
          this.initVimeoVideo();
        } else {
          window.vimeoApiReady();
          document.addEventListener('vimeoReady', this.initVimeoVideo.bind(this));
        }
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.dataset.animate = true;
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '30px 0px 30px 0px' }).observe(this);

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.reloadVideo.bind(this));
        document.addEventListener('shopify:section:unload', this.reloadVideo.bind(this));
        document.addEventListener('shopify:section:reorder', this.reloadVideo.bind(this));
      }
    }

    reloadVideo() {
      if (window.youTubeReady) {
        this.initVideo();
      }

      this.vimeoElm = document.getElementById(`vimeo-player-${this.sectionId}`);
      if (window.vimeoReady && this.vimeoElm) {
        this.initVimeoVideo();
      }
    }

    initVideo() {
      this.ytPlayer = new YT.Player(`yt-player-${this.sectionId}`, this.options);
    }

    onPlayerReady(event) {
      if (this.autoplay) {
        event.target.mute();
        event.target.playVideo();
      }

      const videoDuration = event.target.getDuration();
      setInterval(function () {
        const videoCurrentTime = event.target.getCurrentTime();
        const timeDifference = videoDuration - videoCurrentTime;

        if (2 > timeDifference > 0) {
          event.target.seekTo(0);
        }
      }, 1000);

      if (this.videoOverlay) this.videoOverlay.classList.add('header__video-overlay--fadeOut');
    }

    initVimeoVideo() {
      var args = this.options;
      args.id = this.vimeoId;

      this.vimeoPlayer = new Vimeo.Player(this.vimeoElm, args);
      this.vimeoPlayer.ready().then(this.vimeoPlayerReady.bind(this));
    }

    vimeoPlayerReady() {
      if (this.videoOverlay) this.videoOverlay.classList.add('header__video-overlay--fadeOut');

      if (this.autoplay) {
        this.vimeoPlayer.setMuted(true);
        if (this.vimeoPlayer && typeof this.vimeoPlayer.play === 'function') {
          this.vimeoPlayer.play();
        }
      }
    }
  }

  customElements.define('hero-media', HeroMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["laundry-powder-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('flp'); if(!root)return;
  // carousel
  var car=root.querySelector('[data-flp-carousel]');
  if(car){var track=car.querySelector('.flp-car-track'),dots=car.querySelectorAll('.flp-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.flp-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.flp-vid'),p=w&&w.querySelector('.flp-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    car.querySelector('.flp-prev').onclick=function(){go(i-1);};
    car.querySelector('.flp-next').onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.flp-vid');if(!v)return;var vid=v.querySelector('.flp-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.flp-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.flp-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.flp-vid'),p=w&&w.querySelector('.flp-play');if(p)p.style.display='grid';});});
  }
  // before/after
  var ba=root.querySelector('[data-flp-ba]');
  if(ba){var r=ba.querySelector('.flp-ba-range'),clip=ba.querySelector('.flp-ba-clip'),h=ba.querySelector('.flp-ba-handle'),k=ba.querySelector('.flp-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#flp-form'),sel=root.querySelector('#flp-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-flp-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#flp-buy-wrap')||{}).dataset?root.querySelector('#flp-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.flpOpt,10)||0;
      var on=g.querySelector('.flp-chip.is-on')||g.querySelector('.flp-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.flp-chip');if(!c)return;
        g.querySelectorAll('.flp-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#flp-now'),was=root.querySelector('#flp-was'),
          sp=root.querySelector('#flp-sticky-price'),per=root.querySelector('#flp-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      // main product image follows the selected variant (scent swatch behaviour)
      var img=root.querySelector('#flp-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      // per-size subline follows the selected size
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.flpOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // anchoring badges on size chips: auto Save %/$ from compare-at (Rule of 100)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.flpOpt,10)||0;
      sg.querySelectorAll('.flp-chip').forEach(function(ch){
        if(ch.querySelector('.flp-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='flp-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart upsell modal (multi best-seller picker) ----------
    var modal=root.querySelector('[data-flp-modal]');
    if(modal){
      var cartUrl=modal.getAttribute('data-cart-url')||'/cart';
      var code=modal.getAttribute('data-code');
      var goCart=function(){window.location.href=cartUrl;};
      var fmt=function(cents){return '$'+(Number(cents)/100).toFixed(2);};
      var cards=[].slice.call(modal.querySelectorAll('.flp-up-card'));
      var confirmBtn=modal.querySelector('[data-flp-modal-confirm]');
      var idleLabel=confirmBtn?confirmBtn.textContent:'Add selected';
      function picks(){return cards.filter(function(c){var cb=c.querySelector('.flp-up-cb');return cb&&cb.checked;});}
      // Nothing is ever pre-ticked: browsers restore checkbox state on reload/bfcache,
      // which made the popup open with every staple already selected.
      function resetPicks(){cards.forEach(function(c){var cb=c.querySelector('.flp-up-cb');if(cb)cb.checked=false;c.classList.remove('flp-up-card--on');});}
      function refresh(){
        var chosen=picks(),total=0;
        chosen.forEach(function(c){total+=parseInt(c.getAttribute('data-price'),10)||0;});
        if(confirmBtn){
          confirmBtn.disabled=chosen.length===0;
          confirmBtn.textContent=chosen.length?('Add '+chosen.length+(chosen.length>1?' items':' item')+' — '+fmt(total)):idleLabel;
        }
      }
      cards.forEach(function(c){var cb=c.querySelector('.flp-up-cb');
        if(cb)cb.addEventListener('change',function(){c.classList.toggle('flp-up-card--on',cb.checked);refresh();});});
      // intercept the native add-to-cart submit → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){resetPicks();modal.hidden=false;document.documentElement.style.overflow='hidden';refresh();})
          .catch(goCart);
      },true);
      // CONFIRM → add all selected best sellers (tagged _via for tracking), apply code, land on cart
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=picks();if(!chosen.length)return;
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var items=chosen.map(function(c){return {id:parseInt(c.getAttribute('data-variant'),10),quantity:1,properties:{_via:'laundry-popup'}};});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(cartUrl)):cartUrl;})
          .catch(goCart);
      });
      // X / backdrop / "no thanks" → proceed to cart (the hero product is already in it)
      modal.querySelectorAll('[data-flp-modal-close-go]').forEach(function(el){el.addEventListener('click',goCart);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCart();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mldtier"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('mwl'); if(!root)return;
  // carousel (only present when video URLs are set)
  var car=root.querySelector('[data-mwl-carousel]');
  if(car){var track=car.querySelector('.mwl-car-track'),dots=car.querySelectorAll('.mwl-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.mwl-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.mwl-vid'),p=w&&w.querySelector('.mwl-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    var _prev=car.querySelector('.mwl-prev');if(_prev)_prev.onclick=function(){go(i-1);};
    var _next=car.querySelector('.mwl-next');if(_next)_next.onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.mwl-vid');if(!v)return;var vid=v.querySelector('.mwl-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.mwl-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.mwl-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.mwl-vid'),p=w&&w.querySelector('.mwl-play');if(p)p.style.display='grid';});});
  }
  // before/after (only present when both images are set)
  var ba=root.querySelector('[data-mwl-ba]');
  if(ba){var r=ba.querySelector('.mwl-ba-range'),clip=ba.querySelector('.mwl-ba-clip'),h=ba.querySelector('.mwl-ba-handle'),k=ba.querySelector('.mwl-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#mwl-form'),sel=root.querySelector('#mwl-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-mwl-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#mwl-buy-wrap')||{}).dataset?root.querySelector('#mwl-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.mwlOpt,10)||0;
      var on=g.querySelector('.mwl-chip.is-on')||g.querySelector('.mwl-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.mwl-chip');if(!c)return;
        g.querySelectorAll('.mwl-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#mwl-now'),was=root.querySelector('#mwl-was'),
          sp=root.querySelector('#mwl-sticky-price'),per=root.querySelector('#mwl-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      var img=root.querySelector('#mwl-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.mwlOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // auto Save %/$ badges from compare-at prices (lights up if Tony adds them later)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.mwlOpt,10)||0;
      sg.querySelectorAll('.mwl-chip').forEach(function(ch){
        if(ch.querySelector('.mwl-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='mwl-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart TIERED upsell modal ----------
    var modal=root.querySelector('[data-mwl-modal]');
    if(modal){
      var checkoutUrl='/checkout';
      var goCheckout=function(){window.location.href=checkoutUrl;};
      var HERO=parseInt(modal.getAttribute('data-hero'),10)||0;
      var FREE=parseInt(modal.getAttribute('data-free'),10)||8900;
      var CODES={};try{CODES=JSON.parse(modal.getAttribute('data-codes')||'{}');}catch(e){CODES={};}
      var TIERS=[0,10,15,20,24,24,24,24,24,24];
      var items=[];try{var ij=modal.querySelector('[data-mwl-items]');items=JSON.parse((ij&&ij.textContent)||'[]');}catch(e){items=[];}
      var qty=items.map(function(){return 0;});
      var ladderEl=modal.querySelector('[data-mwl-ladder]'),tilesEl=modal.querySelector('[data-mwl-tiles]');
      var barEl=modal.querySelector('[data-mwl-bar]'),shipEl=modal.querySelector('[data-mwl-ship]');
      var totalEl=modal.querySelector('[data-mwl-total]'),saveEl=modal.querySelector('[data-mwl-save]');
      var confirmBtn=modal.querySelector('[data-mwl-modal-confirm]'),setBtn=modal.querySelector('[data-mwl-setall]');
      var money=function(c){return '$'+(Math.round(c)/100).toFixed(2);};
      var esc=function(s){return String(s).replace(/</g,'&lt;').replace(/>/g,'&gt;');};
      var distinct=function(){var n=0;for(var i=0;i<qty.length;i++){if(qty[i]>0)n++;}return n;};
      var pct=function(){return TIERS[distinct()]||0;};
      var rungs=[['+1',10],['+2',15],['+3',20],['4+',24]];
      if(ladderEl)ladderEl.innerHTML=rungs.map(function(r,i){return '<div class="mwl-t-rung" data-r="'+(i+1)+'">'+r[0]+'<b>'+r[1]+'%</b></div>';}).join('');
      function currentHero(){try{var o=sel.options[sel.selectedIndex];var m=(o&&o.getAttribute('data-price'))||'';var c=parseInt(m.replace(/[^0-9]/g,''),10);return c||HERO;}catch(e){return HERO;}}
      function draw(){
        var p=pct(),d=distinct();
        tilesEl.innerHTML=items.map(function(it,i){
          var q=qty[i],on=q>0,unit=Math.round(it.list*(100-(p||10))/100);
          var right=on
            ? '<div class="mwl-t-qty"><button type="button" class="mwl-t-qbtn" data-dec="'+i+'" aria-label="Remove one">&minus;</button><span class="mwl-t-qn">'+q+'</span><button type="button" class="mwl-t-qbtn plus" data-inc="'+i+'" aria-label="Add one">+</button></div>'
            : '<div class="mwl-t-add" data-add="'+i+'" role="button" tabindex="0" aria-label="Add"></div>';
          var pl=on?('<s>'+money(it.list*q)+'</s><b>'+money(unit*q)+'</b>'):('<s>'+money(it.list)+'</s><b>'+money(unit)+'</b>');
          return '<div class="mwl-t-tile'+(on?' on':'')+'" data-row="'+i+'">'
            +(it.img?'<img src="'+it.img+'" alt="" width="40" height="40" loading="lazy">':'')
            +'<div style="flex:1;min-width:0"><div class="mwl-t-name">'+esc(it.name)+'</div>'
            +(it.scent?'<div class="mwl-t-scent">'+esc(it.scent)+'</div>':'')
            +'<div class="mwl-t-price">'+pl+'</div></div>'+right+'</div>';
        }).join('');
        tilesEl.querySelectorAll('[data-add]').forEach(function(el){el.onclick=function(e){e.stopPropagation();qty[+el.getAttribute('data-add')]=1;draw();};});
        tilesEl.querySelectorAll('[data-row]').forEach(function(el){var i=+el.getAttribute('data-row');if(qty[i]===0)el.onclick=function(){qty[i]=1;draw();};});
        tilesEl.querySelectorAll('[data-inc]').forEach(function(el){el.onclick=function(e){e.stopPropagation();var i=+el.getAttribute('data-inc');qty[i]=Math.min(9,qty[i]+1);draw();};});
        tilesEl.querySelectorAll('[data-dec]').forEach(function(el){el.onclick=function(e){e.stopPropagation();var i=+el.getAttribute('data-dec');qty[i]=Math.max(0,qty[i]-1);draw();};});
        rungs.forEach(function(r,idx){var el=ladderEl.querySelector('[data-r="'+(idx+1)+'"]');if(el)el.classList.toggle('on',idx<3?d>=idx+1:d>=4);});
        var add=0,list=0,units=0;
        for(var i2=0;i2<items.length;i2++){if(qty[i2]>0){add+=Math.round(items[i2].list*(100-p)/100)*qty[i2];list+=items[i2].list*qty[i2];units+=qty[i2];}}
        var cart=HERO+add,save=list-add;
        if(totalEl)totalEl.textContent=money(cart);
        if(barEl)barEl.style.width=Math.min(100,Math.round(cart/FREE*100))+'%';
        if(shipEl)shipEl.innerHTML=cart>=FREE?'<b style="color:var(--primary)">&#10003; Free shipping unlocked</b>':('<b>'+money(FREE-cart)+'</b> away from free shipping');
        if(saveEl)saveEl.textContent=units>0?('You save '+money(save)+' ('+p+'% off)'):'';
        if(confirmBtn)confirmBtn.textContent=units>0?('Add '+units+(units>1?' items':' item')+' & checkout'):'Take me to checkout';
      }
      if(setBtn)setBtn.onclick=function(){var all=true;for(var i=0;i<qty.length;i++){if(qty[i]===0){all=false;break;}}for(var j=0;j<qty.length;j++){qty[j]=all?0:1;}draw();};
      // intercept native add-to-cart → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){HERO=currentHero();for(var k=0;k<qty.length;k++){qty[k]=0;}modal.hidden=false;document.documentElement.style.overflow='hidden';draw();})
          .catch(goCheckout);
      },true);
      // CONFIRM → add all ticked units at their quantity, apply the tier code, go to checkout
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=[];for(var i=0;i<items.length;i++){if(qty[i]>0)chosen.push({id:items[i].variant,quantity:qty[i],properties:{_via:'mould-popup-tiered'}});}
        if(!chosen.length){goCheckout();return;}
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var code=CODES[String(Math.min(distinct(),4))]||'';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:chosen})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(checkoutUrl)):checkoutUrl;})
          .catch(goCheckout);
      });
      // X / backdrop / "no thanks" → proceed to checkout (hero already in cart)
      modal.querySelectorAll('[data-mwl-modal-close-go]').forEach(function(el){el.addEventListener('click',goCheckout);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCheckout();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
  
const hamburger = document.getElementById('hamburger');
const mobileDrawerMenu = document.getElementById('mobileDrawerMenu');
const closeBtn = document.getElementById('closeBtn');
const overlay = document.getElementById('overlay');

hamburger.addEventListener('click', () => {
  mobileDrawerMenu.classList.add('active');
  overlay.classList.add('active');
});

closeBtn.addEventListener('click', () => {
  mobileDrawerMenu.classList.remove('active');
  overlay.classList.remove('active');
});

overlay.addEventListener('click', () => {
  mobileDrawerMenu.classList.remove('active');
  overlay.classList.remove('active');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mould-essentials-bundle-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('meb'); if(!root)return;
  // carousel (only present when video URLs are set)
  var car=root.querySelector('[data-meb-carousel]');
  if(car){var track=car.querySelector('.meb-car-track'),dots=car.querySelectorAll('.meb-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.meb-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.meb-vid'),p=w&&w.querySelector('.meb-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    var _prev=car.querySelector('.meb-prev');if(_prev)_prev.onclick=function(){go(i-1);};
    var _next=car.querySelector('.meb-next');if(_next)_next.onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.meb-vid');if(!v)return;var vid=v.querySelector('.meb-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.meb-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.meb-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.meb-vid'),p=w&&w.querySelector('.meb-play');if(p)p.style.display='grid';});});
  }
  // before/after (only present when both images are set)
  var ba=root.querySelector('[data-meb-ba]');
  if(ba){var r=ba.querySelector('.meb-ba-range'),clip=ba.querySelector('.meb-ba-clip'),h=ba.querySelector('.meb-ba-handle'),k=ba.querySelector('.meb-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#meb-form'),sel=root.querySelector('#meb-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-meb-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#meb-buy-wrap')||{}).dataset?root.querySelector('#meb-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.mebOpt,10)||0;
      var on=g.querySelector('.meb-chip.is-on')||g.querySelector('.meb-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.meb-chip');if(!c)return;
        g.querySelectorAll('.meb-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      // single-variant bundle: no chips to map — native <select> already holds the variant
      if(!groups.length){ if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;} return; }
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#meb-now'),was=root.querySelector('#meb-was'),
          sp=root.querySelector('#meb-sticky-price'),per=root.querySelector('#meb-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      var img=root.querySelector('#meb-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.mebOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // auto Save %/$ badges from compare-at prices (lights up if Tony adds them later)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.mebOpt,10)||0;
      sg.querySelectorAll('.meb-chip').forEach(function(ch){
        if(ch.querySelector('.meb-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='meb-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart upsell modal (multi-staple picker) ----------
    var modal=root.querySelector('[data-meb-modal]');
    if(modal){
      var cartUrl=modal.getAttribute('data-cart-url')||'/cart';
      var code=modal.getAttribute('data-code');
      var goCart=function(){window.location.href=cartUrl;};
      var fmt=function(cents){return '$'+(Number(cents)/100).toFixed(2);};
      var cards=[].slice.call(modal.querySelectorAll('.meb-up-card'));
      var confirmBtn=modal.querySelector('[data-meb-modal-confirm]');
      var idleLabel=confirmBtn?confirmBtn.textContent:'Add selected';
      function picks(){return cards.filter(function(c){var cb=c.querySelector('.meb-up-cb');return cb&&cb.checked;});}
      function refresh(){
        var chosen=picks(),total=0;
        chosen.forEach(function(c){total+=parseInt(c.getAttribute('data-price'),10)||0;});
        if(confirmBtn){
          confirmBtn.disabled=chosen.length===0;
          confirmBtn.textContent=chosen.length?('Add '+chosen.length+(chosen.length>1?' items':' item')+' — '+fmt(total)):idleLabel;
        }
      }
      cards.forEach(function(c){var cb=c.querySelector('.meb-up-cb');
        if(cb)cb.addEventListener('change',function(){c.classList.toggle('meb-up-card--on',cb.checked);refresh();});});
      // intercept the native add-to-cart submit → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){modal.hidden=false;document.documentElement.style.overflow='hidden';refresh();})
          .catch(goCart);
      },true);
      // CONFIRM → add all selected staples, apply the code, land on cart
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=picks();if(!chosen.length)return;
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var items=chosen.map(function(c){return {id:parseInt(c.getAttribute('data-variant'),10),quantity:1,properties:{_via:'mould-popup'}};});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(cartUrl)):cartUrl;})
          .catch(goCart);
      });
      // X / backdrop / "no thanks" → proceed to cart (the hero product is already in it)
      modal.querySelectorAll('[data-meb-modal-close-go]').forEach(function(el){el.addEventListener('click',goCart);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCart();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mould-reactivation-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('mrb'); if(!root) return;
  // sticky CTA reveals on ALL widths once the hero (with its own CTA) is scrolled past
  var hero=root.querySelector('.mrb-hero'), sticky=root.querySelector('.mrb-sticky');
  function onScroll(){ if(!hero||!sticky) return;
    sticky.classList.toggle('is-on', hero.getBoundingClientRect().bottom < 40); }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
  onScroll();
  // hero video carousel — swipe, arrows, dots, tap-to-play (same as the other LPs)
  var car=root.querySelector('[data-mrb-carousel]');
  if(car){
    var track=car.querySelector('.mrb-car-track'), dots=car.querySelectorAll('.mrb-dot'),
        n=track.children.length, i=0;
    function stopAll(except){car.querySelectorAll('.mrb-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.mrb-vid'),p=w&&w.querySelector('.mrb-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    var _p=car.querySelector('.mrb-prev');if(_p)_p.onclick=function(){go(i-1);};
    var _n=car.querySelector('.mrb-next');if(_n)_n.onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;
    track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.mrb-vid');if(!v)return;var vid=v.querySelector('.mrb-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.mrb-play');if(pl)pl.style.display=vid.paused?'grid':'none';
      var mu=v.querySelector('.mrb-muted');if(mu)mu.style.display=vid.paused?'block':'none';});
    car.querySelectorAll('.mrb-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.mrb-vid'),p=w&&w.querySelector('.mrb-play');if(p)p.style.display='grid';});});
  }
  // countdown
  var dl=root.querySelector('.mrb-deadline');
  if(dl){
    var target=new Date(dl.getAttribute('data-deadline')).getTime();
    var clock=dl.querySelector('[data-mrb-clock]');
    var expired=dl.getAttribute('data-expired')||'Offer closed';
    function tick(){
      var now=new Date().getTime(), d=target-now;
      if(isNaN(target)){dl.style.display='none';return;}
      if(d<=0){clock.textContent='';dl.innerHTML='<span class="mrb-dl-dot"></span>'+expired;return;}
      var days=Math.floor(d/86400000), h=Math.floor(d%86400000/3600000), m=Math.floor(d%3600000/60000), s=Math.floor(d%60000/1000);
      clock.textContent=(days>0?days+'d ':'')+h+'h '+m+'m '+(days>0?'':s+'s');
    }
    tick(); setInterval(tick,1000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mould-wall-cleaner-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('mwl'); if(!root)return;
  // carousel (only present when video URLs are set)
  var car=root.querySelector('[data-mwl-carousel]');
  if(car){var track=car.querySelector('.mwl-car-track'),dots=car.querySelectorAll('.mwl-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.mwl-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.mwl-vid'),p=w&&w.querySelector('.mwl-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    var _prev=car.querySelector('.mwl-prev');if(_prev)_prev.onclick=function(){go(i-1);};
    var _next=car.querySelector('.mwl-next');if(_next)_next.onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.mwl-vid');if(!v)return;var vid=v.querySelector('.mwl-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.mwl-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.mwl-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.mwl-vid'),p=w&&w.querySelector('.mwl-play');if(p)p.style.display='grid';});});
  }
  // before/after (only present when both images are set)
  var ba=root.querySelector('[data-mwl-ba]');
  if(ba){var r=ba.querySelector('.mwl-ba-range'),clip=ba.querySelector('.mwl-ba-clip'),h=ba.querySelector('.mwl-ba-handle'),k=ba.querySelector('.mwl-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#mwl-form'),sel=root.querySelector('#mwl-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-mwl-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#mwl-buy-wrap')||{}).dataset?root.querySelector('#mwl-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.mwlOpt,10)||0;
      var on=g.querySelector('.mwl-chip.is-on')||g.querySelector('.mwl-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.mwl-chip');if(!c)return;
        g.querySelectorAll('.mwl-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#mwl-now'),was=root.querySelector('#mwl-was'),
          sp=root.querySelector('#mwl-sticky-price'),per=root.querySelector('#mwl-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      var img=root.querySelector('#mwl-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.mwlOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // auto Save %/$ badges from compare-at prices (lights up if Tony adds them later)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.mwlOpt,10)||0;
      sg.querySelectorAll('.mwl-chip').forEach(function(ch){
        if(ch.querySelector('.mwl-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='mwl-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart upsell modal (multi-staple picker) ----------
    var modal=root.querySelector('[data-mwl-modal]');
    if(modal){
      var cartUrl=modal.getAttribute('data-cart-url')||'/cart';
      var code=modal.getAttribute('data-code');
      var goCart=function(){window.location.href=cartUrl;};var goCheckout=function(){window.location.href='/checkout';};
      var fmt=function(cents){return '$'+(Number(cents)/100).toFixed(2);};
      var cards=[].slice.call(modal.querySelectorAll('.mwl-up-card'));
      var confirmBtn=modal.querySelector('[data-mwl-modal-confirm]');
      var idleLabel=confirmBtn?confirmBtn.textContent:'Add selected';
      function picks(){return cards.filter(function(c){var cb=c.querySelector('.mwl-up-cb');return cb&&cb.checked;});}
      // Nothing is ever pre-ticked: browsers restore checkbox state on reload/bfcache,
      // which made the popup open with every item already selected.
      function resetPicks(){cards.forEach(function(c){var cb=c.querySelector('.mwl-up-cb');if(cb)cb.checked=false;c.classList.remove('mwl-up-card--on');});}
      function refresh(){
        var chosen=picks(),total=0;
        chosen.forEach(function(c){total+=parseInt(c.getAttribute('data-price'),10)||0;});
        if(confirmBtn){
          confirmBtn.disabled=chosen.length===0;
          confirmBtn.textContent=chosen.length?('Add '+chosen.length+(chosen.length>1?' items':' item')+' — '+fmt(total)):idleLabel;
        }
      }
      cards.forEach(function(c){var cb=c.querySelector('.mwl-up-cb');
        if(cb)cb.addEventListener('change',function(){c.classList.toggle('mwl-up-card--on',cb.checked);refresh();});});
      // intercept the native add-to-cart submit → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){resetPicks();modal.hidden=false;document.documentElement.style.overflow='hidden';refresh();})
          .catch(goCart);
      },true);
      // CONFIRM → add all selected staples, apply the code, land on cart
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=picks();if(!chosen.length)return;
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var items=chosen.map(function(c){return {id:parseInt(c.getAttribute('data-variant'),10),quantity:1,properties:{_via:'mould-popup'}};});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent('/checkout')):'/checkout';})
          .catch(goCart);
      });
      // X / backdrop / "no thanks" → proceed to cart (the hero product is already in it)
      modal.querySelectorAll('[data-mwl-modal-close-go]').forEach(function(el){el.addEventListener('click',goCheckout);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCheckout();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const sectionId = this.dataset.sectionId;
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Contact_${sectionId}-email-error`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function () {
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error')
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        existingEmailMsg.classList.add('hide');
      });

      if (searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector('#Contact_newsletter').scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', 'Contact_newsletter-email-error');
          inputEmailNewsletter.setAttribute('data_form_status', true);

          errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  class RichText extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.dataset.animation = true;
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('rich-text', RichText);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shower-cleaner-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('slp'); if(!root)return;
  // carousel (only present when video URLs are set)
  var car=root.querySelector('[data-slp-carousel]');
  if(car){var track=car.querySelector('.slp-car-track'),dots=car.querySelectorAll('.slp-dot'),
    n=track.children.length,i=0;
    function stopAll(except){car.querySelectorAll('.slp-video').forEach(function(o){
      if(o!==except){o.pause();var w=o.closest('.slp-vid'),p=w&&w.querySelector('.slp-play');if(p)p.style.display='grid';}});}
    function go(k){i=(k+n)%n;track.style.transform='translateX('+(-i*100)+'%)';stopAll(null);
      dots.forEach(function(d,j){d.setAttribute('aria-selected',j===i?'true':'false');});}
    var _prev=car.querySelector('.slp-prev');if(_prev)_prev.onclick=function(){go(i-1);};
    var _next=car.querySelector('.slp-next');if(_next)_next.onclick=function(){go(i+1);};
    dots.forEach(function(d,j){d.onclick=function(){go(j);};});
    var x0=null;track.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
    track.addEventListener('touchend',function(e){if(x0==null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)go(i+(dx<0?1:-1));x0=null;});
    car.addEventListener('click',function(e){var v=e.target.closest('.slp-vid');if(!v)return;var vid=v.querySelector('.slp-video');if(!vid)return;
      if(vid.paused){stopAll(vid);vid.muted=false;vid.play();}else{vid.pause();}
      var pl=v.querySelector('.slp-play');if(pl)pl.style.display=vid.paused?'grid':'none';});
    car.querySelectorAll('.slp-video').forEach(function(o){o.addEventListener('ended',function(){
      o.currentTime=0;var w=o.closest('.slp-vid'),p=w&&w.querySelector('.slp-play');if(p)p.style.display='grid';});});
  }
  // before/after (only present when both images are set)
  var ba=root.querySelector('[data-slp-ba]');
  if(ba){var r=ba.querySelector('.slp-ba-range'),clip=ba.querySelector('.slp-ba-clip'),h=ba.querySelector('.slp-ba-handle'),k=ba.querySelector('.slp-ba-knob');
    r.addEventListener('input',function(){var v=this.value;clip.style.width=v+'%';h.style.left=v+'%';k.style.left=v+'%';});}
  // variant selector: map option chips -> hidden <select name=id>
  var form=root.querySelector('#slp-form'),sel=root.querySelector('#slp-variant');
  if(form&&sel){
    var groups=form.querySelectorAll('[data-slp-opt]'),chosen=[];
    var money=function(s){return parseFloat(String(s||'').replace(/[^0-9.]/g,''))||0;};
    // per-size sublines from settings ("value|text" per line)
    var perMap={},perRaw=(root.querySelector('#slp-buy-wrap')||{}).dataset?root.querySelector('#slp-buy-wrap').dataset.sizeLines:'';
    (perRaw||'').split('\n').forEach(function(l){var p=l.split('|');if(p.length>1)perMap[p[0].trim()]=p.slice(1).join('|').trim();});
    groups.forEach(function(g){var gi=parseInt(g.dataset.slpOpt,10)||0;
      var on=g.querySelector('.slp-chip.is-on')||g.querySelector('.slp-chip');
      if(on&&!on.classList.contains('is-on'))on.classList.add('is-on');
      chosen[gi]=on?on.dataset.val:'';
      g.addEventListener('click',function(e){var c=e.target.closest('.slp-chip');if(!c)return;
        g.querySelectorAll('.slp-chip').forEach(function(x){x.classList.remove('is-on');});c.classList.add('is-on');chosen[gi]=c.dataset.val;sync();});});
    function findOpt(want){var o=null;[].forEach.call(sel.options,function(x){if(x.dataset.opts===want)o=x;});return o;}
    var addBtnEl=form.querySelector('[name="add"]'),addLabel=addBtnEl?addBtnEl.textContent:'Add to cart';
    function sync(){
      var opt=findOpt(chosen.join(' / '));
      if(!opt||opt.disabled){
        if(addBtnEl){addBtnEl.disabled=true;addBtnEl.textContent='Unavailable in this combination';}
        return;
      }
      if(addBtnEl){addBtnEl.disabled=false;addBtnEl.textContent=addLabel;}
      sel.value=opt.value;
      var now=root.querySelector('#slp-now'),was=root.querySelector('#slp-was'),
          sp=root.querySelector('#slp-sticky-price'),per=root.querySelector('#slp-per');
      if(now)now.textContent=opt.dataset.price;
      if(sp)sp.textContent=opt.dataset.price;
      var p=money(opt.dataset.price),c=money(opt.dataset.cprice);
      if(was){if(c>p){was.textContent=opt.dataset.cprice;was.hidden=false;}else{was.hidden=true;}}
      var img=root.querySelector('#slp-prod-img');
      if(img&&opt.dataset.img)img.src=opt.dataset.img;
      var sg=root.querySelector('[data-size-group]');
      if(per&&sg){var sv=chosen[parseInt(sg.dataset.slpOpt,10)||0];if(perMap[sv])per.textContent=perMap[sv];}
    }
    // auto Save %/$ badges from compare-at prices (lights up if Tony adds them later)
    var sg=root.querySelector('[data-size-group]');
    if(sg){var si=parseInt(sg.dataset.slpOpt,10)||0;
      sg.querySelectorAll('.slp-chip').forEach(function(ch){
        if(ch.querySelector('.slp-badge'))return;
        var probe=chosen.slice();probe[si]=ch.dataset.val;
        var o=findOpt(probe.join(' / '));if(!o)return;
        var p=money(o.dataset.price),c=money(o.dataset.cprice);
        if(c>p){var b=document.createElement('span');b.className='slp-badge';
          b.textContent=p>=100?('Save $'+Math.round(c-p)):('Save '+Math.round((c-p)/c*100)+'%');
          ch.appendChild(b);}
      });}

    // ---------- post-add-to-cart upsell modal (multi-staple picker) ----------
    var modal=root.querySelector('[data-slp-modal]');
    if(modal){
      var cartUrl=modal.getAttribute('data-cart-url')||'/cart';
      var code=modal.getAttribute('data-code');
      var goCart=function(){window.location.href=cartUrl;};var goCheckout=function(){window.location.href='/checkout';};
      var fmt=function(cents){return '$'+(Number(cents)/100).toFixed(2);};
      var cards=[].slice.call(modal.querySelectorAll('.slp-up-card'));
      var confirmBtn=modal.querySelector('[data-slp-modal-confirm]');
      var idleLabel=confirmBtn?confirmBtn.textContent:'Add selected';
      function picks(){return cards.filter(function(c){var cb=c.querySelector('.slp-up-cb');return cb&&cb.checked;});}
      // Nothing is ever pre-ticked: browsers restore checkbox state on reload/bfcache,
      // which made the popup open with every staple already selected.
      function resetPicks(){cards.forEach(function(c){var cb=c.querySelector('.slp-up-cb');if(cb)cb.checked=false;c.classList.remove('slp-up-card--on');});}
      function refresh(){
        var chosen=picks(),total=0;
        chosen.forEach(function(c){total+=parseInt(c.getAttribute('data-price'),10)||0;});
        if(confirmBtn){
          confirmBtn.disabled=chosen.length===0;
          confirmBtn.textContent=chosen.length?('Add '+chosen.length+(chosen.length>1?' items':' item')+' — '+fmt(total)):idleLabel;
        }
      }
      cards.forEach(function(c){var cb=c.querySelector('.slp-up-cb');
        if(cb)cb.addEventListener('change',function(){c.classList.toggle('slp-up-card--on',cb.checked);refresh();});});
      // intercept the native add-to-cart submit → add hero, open modal (capture+stop so theme JS doesn't also fire)
      form.addEventListener('submit',function(e){
        if(addBtnEl&&addBtnEl.disabled)return;
        e.preventDefault();e.stopImmediatePropagation();
        if(addBtnEl)addBtnEl.disabled=true;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:parseInt(sel.value,10),quantity:1}]})})
          .then(function(r){return r.ok?r.json():Promise.reject();})
          .then(function(){resetPicks();modal.hidden=false;document.documentElement.style.overflow='hidden';refresh();})
          .catch(goCart);
      },true);
      // CONFIRM → add all selected staples, apply the code, land on cart
      if(confirmBtn)confirmBtn.addEventListener('click',function(){
        var chosen=picks();if(!chosen.length)return;
        confirmBtn.disabled=true;confirmBtn.textContent='Adding…';
        var items=chosen.map(function(c){return {id:parseInt(c.getAttribute('data-variant'),10),quantity:1,properties:{_via:'shower-popup'}};});
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
          .then(function(){window.location.href=code?('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent('/checkout')):'/checkout';})
          .catch(goCart);
      });
      // X / backdrop / "no thanks" → proceed to cart (the hero product is already in it)
      modal.querySelectorAll('[data-slp-modal-close-go]').forEach(function(el){el.addEventListener('click',goCheckout);});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)goCheckout();});
    }

    sync();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-new"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const slides = document.querySelectorAll('.slide');
    let currentSlide = 0;

    function showSlide(index) {
        slides.forEach((slide, idx) => {
            slide.classList.remove('active');
            if (idx === index) {
                slide.classList.add('active');
            }
        });
    }

    document.querySelector('.next-button').addEventListener('click', function() {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
    });

    document.querySelector('.prev-button').addEventListener('click', function() {
        currentSlide = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(currentSlide);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-hero-image"] && !Shopify.designMode) return;
  try {
    
  class HeroImage extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.dataset.animate = true;
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '30px 0px 30px 0px' }).observe(this);
    }
  }

  customElements.define('hero-image', HeroImage);

  } catch(e) { console.error(e); }
})();
})();
